import SalarieDepartementNaissance from '@/generated/controls/salarie/SalarieDepartementNaissance.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: SalarieDepartementNaissance
})
